import React from "react"
import styled from '@emotion/styled'
import { useLocalization } from "gatsby-theme-i18n";
import LinkItem from "../LinkItem/LinkItem";
import Logo from "../StyledComponents/Logo";
import * as breakpoint from '../../styles/breakpoints.module.scss';


const Sitemap = () => {

  const { t, currentLocaleObj } = useLocalization();

  
  return(
  <SitemapWrapper>
    <SitemapLogoCol>
      <EventLogo fade to={`/${currentLocaleObj.prefix}/`}>
        <Logo theme={'dark'} />
      </EventLogo>
    </SitemapLogoCol>
    <SitemapNav>
      <SitemapCol>
        
        <ul>
          <li><SitemapTitle>{t('nav.footer.nav.event.label')}</SitemapTitle></li>
          <li><SitemapLink fade to={`/${currentLocaleObj.prefix}/`}>{t('nav.home.label')}</SitemapLink></li>
          <li><SitemapLink fade to={`/${currentLocaleObj.prefix}/update/`}>{t('nav.update.label')}</SitemapLink></li>
          <li><SitemapLink fade to={`/${currentLocaleObj.prefix}/about/`}>{t('nav.about.label')}</SitemapLink></li>
          <li><SitemapLink fade to={`/${currentLocaleObj.prefix}/program/`}>{t('nav.program.label')}</SitemapLink></li>
          <li><SitemapLink fade to={`/${currentLocaleObj.prefix}/activity/`}>{t('nav.activity.label')}</SitemapLink></li>
          <li><SitemapLink fade to={`/${currentLocaleObj.prefix}/message-board/`}>{t('nav.comment_board.label')}</SitemapLink></li>
          <li><SitemapLink fade to={`/${currentLocaleObj.prefix}/goods/`}>{t('nav.goods.label')}</SitemapLink></li>
          <li><SitemapLink fade to={`/${currentLocaleObj.prefix}/ingame-item/`}>{t('nav.ingame_item.label')}</SitemapLink></li>
          <li><SitemapLink fade to={`/${currentLocaleObj.prefix}/streaming/`}>{t('nav.streaming.button.label')}</SitemapLink></li>
        </ul>
      </SitemapCol>
      <SitemapCol>
        
        <ul>
          <li><SitemapTitle>{t('nav.footer.nav.fanfest.label')}</SitemapTitle></li>
          <li><SitemapLink href={t('nav.footer.nav.fanfest.paris_2019.url')}>{t('nav.footer.nav.fanfest.paris_2019.label')}</SitemapLink></li>
          <li><SitemapLink href={t('nav.footer.nav.fanfest.tokyo_2019.url')}>{t('nav.footer.nav.fanfest.tokyo_2019.label')}</SitemapLink></li>
          <li><SitemapLink href={t('nav.footer.nav.fanfest.vegas_2018.url')}>{t('nav.footer.nav.fanfest.vegas_2018.label')}</SitemapLink></li>
        </ul>
      </SitemapCol>
      <SitemapCol>
        
        <ul>
          <li><SitemapTitle>{t('nav.footer.nav.site.label')}</SitemapTitle></li>
          <li><SitemapLink href={t('nav.footer.nav.site.privacy.url')}>{t('nav.footer.nav.site.privacy.label')}</SitemapLink></li>
          <li><SitemapLink fade to={`/${currentLocaleObj.prefix}/license`}>{t('nav.footer.nav.site.licence.label')}</SitemapLink></li>
        </ul>
      </SitemapCol>
    </SitemapNav>
  </SitemapWrapper>)
}

export default Sitemap;

const SitemapWrapper = styled.div`
  
  padding:0 32px;
  margin:0 auto;

  display:flex;
  @media only screen and (max-width: ${breakpoint.smMax}){
    flex-wrap:wrap;
    padding:0 80px;
    > nav{
      &:nth-of-type(1){
        width:100%;
      }
      &:nth-of-type(2),&:nth-of-type(3),&:nth-of-type(4){
        width:33.3%;
        display:flex;
        flex-direction:column;
        align-items:center;
      }
    }
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:0 24px;
    > nav{
      width:100% !important;
      display:block !important;

      &:nth-of-type(2),&:nth-of-type(3),&:nth-of-type(4){
        margin-bottom:24px;
      }
    }
  }
`

const EventLogo = styled(LinkItem)`
  display:block;
  width:128px;
  height:85px;
  @media only screen and (max-width: ${breakpoint.smMax}){
    margin:0 auto 32px;
  }
`
const SitemapLogoCol = styled.nav`
  width:240px;
`

const SitemapCol = styled.nav`
  width:auto;margin-right:48px;
  ul{
    list-style-type:none;
  }
  &:last-of-type{
    margin-right:0;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin:0 0 32px 0;
    &:last-of-type{
      margin:0;
    }
  }
`

const SitemapTitle = styled.div`
  font-size: 14px;
  line-height: 24px;
  font-weight:bold;
  color:#ADADAF;
  margin-bottom:16px;
`
const SitemapLink = styled(LinkItem)`
  font-size: 14px;
  line-height: 24px;
  color: #F2F2F5;
  margin-bottom:12px;
  display:inline-block;
  text-decoration:none;

  &.disabled{
    color:#838385;
  }

  &:hover:not(.disabled){
    text-decoration: underline;
  }
`
const SitemapNav = styled.div`
  display:flex;
  width:calc(100% - 240px);

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:100%;
    justify-content:center;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    display:block;
    margin-bottom:48px;
  }
`
